// THIS IS A GENERATED FILE
import * as Types from "../../graphql/types"

import gql from "graphql-tag"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type SupportedCdnIntegrationsQueryVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type SupportedCdnIntegrationsQuery = { __typename?: "Query" } & {
  supportedCDNIntegrations?: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: "CdnIntegration" } & Pick<
          Types.CdnIntegration,
          "id" | "siteId" | "vendor" | "connected" | "config"
        >
      >
    >
  >
}

export type SetCdnConfigMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  serviceId: Types.Scalars["String"]
  serviceName: Types.Scalars["String"]
  accountName?: Types.Maybe<Types.Scalars["String"]>
  vendor: Types.CdnVendor
}>

export type SetCdnConfigMutation = { __typename?: "Mutation" } & {
  setCDNConfig?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type DisconnectCloudCdnToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type DisconnectCloudCdnToSiteMutation = { __typename?: "Mutation" } & {
  disconnectCloudCdnToSite?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type DeleteCdnFromSiteByVendorMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  vendor: Types.CdnVendor
}>

export type DeleteCdnFromSiteByVendorMutation = { __typename?: "Mutation" } & {
  deleteCDNFromSiteByVendor?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export const SupportedCdnIntegrationsDocument = gql`
  query SupportedCDNIntegrations($siteId: UUID!) {
    supportedCDNIntegrations(siteId: $siteId) {
      id
      siteId
      vendor
      connected
      config
    }
  }
`

/**
 * __useSupportedCdnIntegrationsQuery__
 *
 * To run a query within a React component, call `useSupportedCdnIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCdnIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedCdnIntegrationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSupportedCdnIntegrationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SupportedCdnIntegrationsQuery,
    SupportedCdnIntegrationsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    SupportedCdnIntegrationsQuery,
    SupportedCdnIntegrationsQueryVariables
  >(SupportedCdnIntegrationsDocument, baseOptions)
}
export function useSupportedCdnIntegrationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SupportedCdnIntegrationsQuery,
    SupportedCdnIntegrationsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    SupportedCdnIntegrationsQuery,
    SupportedCdnIntegrationsQueryVariables
  >(SupportedCdnIntegrationsDocument, baseOptions)
}
export type SupportedCdnIntegrationsQueryHookResult = ReturnType<
  typeof useSupportedCdnIntegrationsQuery
>
export type SupportedCdnIntegrationsLazyQueryHookResult = ReturnType<
  typeof useSupportedCdnIntegrationsLazyQuery
>
export type SupportedCdnIntegrationsQueryResult = ApolloReactCommon.QueryResult<
  SupportedCdnIntegrationsQuery,
  SupportedCdnIntegrationsQueryVariables
>
export const SetCdnConfigDocument = gql`
  mutation setCDNConfig(
    $siteId: UUID!
    $serviceId: String!
    $serviceName: String!
    $accountName: String
    $vendor: CdnVendor!
  ) {
    setCDNConfig(
      siteId: $siteId
      serviceId: $serviceId
      serviceName: $serviceName
      accountName: $accountName
      vendor: $vendor
    ) {
      success
      message
      errorType
    }
  }
`
export type SetCdnConfigMutationFn = ApolloReactCommon.MutationFunction<
  SetCdnConfigMutation,
  SetCdnConfigMutationVariables
>

/**
 * __useSetCdnConfigMutation__
 *
 * To run a mutation, you first call `useSetCdnConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCdnConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCdnConfigMutation, { data, loading, error }] = useSetCdnConfigMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      serviceId: // value for 'serviceId'
 *      serviceName: // value for 'serviceName'
 *      accountName: // value for 'accountName'
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useSetCdnConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetCdnConfigMutation,
    SetCdnConfigMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SetCdnConfigMutation,
    SetCdnConfigMutationVariables
  >(SetCdnConfigDocument, baseOptions)
}
export type SetCdnConfigMutationHookResult = ReturnType<
  typeof useSetCdnConfigMutation
>
export type SetCdnConfigMutationResult = ApolloReactCommon.MutationResult<
  SetCdnConfigMutation
>
export type SetCdnConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SetCdnConfigMutation,
  SetCdnConfigMutationVariables
>
export const DisconnectCloudCdnToSiteDocument = gql`
  mutation DisconnectCloudCdnToSite($siteId: UUID!) {
    disconnectCloudCdnToSite(siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type DisconnectCloudCdnToSiteMutationFn = ApolloReactCommon.MutationFunction<
  DisconnectCloudCdnToSiteMutation,
  DisconnectCloudCdnToSiteMutationVariables
>

/**
 * __useDisconnectCloudCdnToSiteMutation__
 *
 * To run a mutation, you first call `useDisconnectCloudCdnToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectCloudCdnToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectCloudCdnToSiteMutation, { data, loading, error }] = useDisconnectCloudCdnToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDisconnectCloudCdnToSiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisconnectCloudCdnToSiteMutation,
    DisconnectCloudCdnToSiteMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DisconnectCloudCdnToSiteMutation,
    DisconnectCloudCdnToSiteMutationVariables
  >(DisconnectCloudCdnToSiteDocument, baseOptions)
}
export type DisconnectCloudCdnToSiteMutationHookResult = ReturnType<
  typeof useDisconnectCloudCdnToSiteMutation
>
export type DisconnectCloudCdnToSiteMutationResult = ApolloReactCommon.MutationResult<
  DisconnectCloudCdnToSiteMutation
>
export type DisconnectCloudCdnToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DisconnectCloudCdnToSiteMutation,
  DisconnectCloudCdnToSiteMutationVariables
>
export const DeleteCdnFromSiteByVendorDocument = gql`
  mutation DeleteCDNFromSiteByVendor($siteId: UUID!, $vendor: CdnVendor!) {
    deleteCDNFromSiteByVendor(siteId: $siteId, vendor: $vendor) {
      success
      message
      errorType
    }
  }
`
export type DeleteCdnFromSiteByVendorMutationFn = ApolloReactCommon.MutationFunction<
  DeleteCdnFromSiteByVendorMutation,
  DeleteCdnFromSiteByVendorMutationVariables
>

/**
 * __useDeleteCdnFromSiteByVendorMutation__
 *
 * To run a mutation, you first call `useDeleteCdnFromSiteByVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCdnFromSiteByVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCdnFromSiteByVendorMutation, { data, loading, error }] = useDeleteCdnFromSiteByVendorMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useDeleteCdnFromSiteByVendorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCdnFromSiteByVendorMutation,
    DeleteCdnFromSiteByVendorMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteCdnFromSiteByVendorMutation,
    DeleteCdnFromSiteByVendorMutationVariables
  >(DeleteCdnFromSiteByVendorDocument, baseOptions)
}
export type DeleteCdnFromSiteByVendorMutationHookResult = ReturnType<
  typeof useDeleteCdnFromSiteByVendorMutation
>
export type DeleteCdnFromSiteByVendorMutationResult = ApolloReactCommon.MutationResult<
  DeleteCdnFromSiteByVendorMutation
>
export type DeleteCdnFromSiteByVendorMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteCdnFromSiteByVendorMutation,
  DeleteCdnFromSiteByVendorMutationVariables
>
